/* src/app/questionnaire/link/link.component.scss */
.bbutton {
  --icon-font-size: 50px;
  color: #000;
  background-color: transparent;
}
/*# sourceMappingURL=link.component.css.map */
